import React, {useRef} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// import ResizableBox from './ResizableBox';

import {mergeRefs} from '../../../lib/refHelper';

const DragItemComponent = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  grid-row-start: ${(prop) => prop.columnStart};
  grid-row-end: ${(prop) => prop.columnStart + prop.columnSize};
  grid-column-start: ${(prop) => (prop.row > 1 ? prop.row - prop.rowSize - prop.rowStart + 2 : '0')};
  grid-column-end: ${(prop) => prop.row - prop.rowStart + 2};
  cursor: move;
  display: grid;
  grid-template-columns: repeat(${(prop) => prop.rowSize}, 1fr);
  grid-template-rows: repeat(${(prop) => prop.columnSize}, 1fr);
  pointer-events: auto;
  border: solid 2px #0059cc;
`;

const DragItemContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: repeat(${(prop) => prop.col}, 1fr);
  grid-template-columns: repeat(${(prop) => prop.row}, 1fr);
  gap: 10;
  pointer-events: none;
`;

function DragItem({dropZoneID, setDraggedLayout, setDraggedHandle, drag, layout, row, col}) {
  const containerRef = useRef(null);
  const itemRef = useRef(null);

  const getHandlePosition = (e) => {
    const {left, top, height: containerHeight, width: containerWidth} = itemRef.current.getBoundingClientRect();
    const x = e.clientX - left; // x position within the element.
    const y = e.clientY - top; // y position within the element.

    const wellSize = {height: containerHeight / layout.size.column, width: containerWidth / layout.size.row};

    const rowPosition = Math.ceil((containerWidth - x) / wellSize.width) + layout.start.row - 1;
    const colPosition = Math.ceil(y / wellSize.height) + layout.start.column - 1;

    return [rowPosition, colPosition];
  };

  const onMouseDown = (e) => {
    const [rowPosition, colPosition] = getHandlePosition(e);
    setDraggedLayout({...layout, dropZoneID, draggedElement: itemRef.current.getBoundingClientRect()});
    setDraggedHandle({row: rowPosition, column: colPosition});
  };

  return (
    <DragItemContainer ref={containerRef} row={row} col={col} style={{gap: `${row === 1 || col === 1 ? '2%' : 0}`}}>
      <DragItemComponent
        ref={mergeRefs(drag, itemRef)}
        row={row}
        col={col}
        rowStart={layout.start.row}
        columnStart={layout.start.column}
        rowSize={layout.size.row}
        columnSize={layout.size.column}
        onMouseDown={onMouseDown}
      >
        {/* <ResizableBox
          itemContainer={containerRef.current}
          row={row}
          col={col}
          layout={layout}
        /> */}
      </DragItemComponent>
    </DragItemContainer>
  );
}

DragItem.propTypes = {
  dropZoneID: PropTypes.number.isRequired,
  drag: PropTypes.any.isRequired,
  col: PropTypes.number,
  row: PropTypes.number,
  layout: PropTypes.object,
  setDraggedLayout: PropTypes.func,
  setDraggedHandle: PropTypes.func,
};

DragItem.defaultProps = {
  col: 0,
  row: 0,
  layout: {start: {row: 0, column: 0}, size: {row: 0, column: 0}},
  setDraggedLayout: () => {},
  setDraggedHandle: () => {},
};

export default DragItem;
